<template>
    <div class="text-center" v-if="value">
        <a class="m-nav-grid__item" :href="($lang.current=='en' ? '' :$lang.current ) + '/'+spark.links.company[$lang.current]+'/' +value" target="_blank" v-on:click.stop>
            <i class="m-nav-grid__icon flaticon-time"></i>
        </a>
    </div>
</template>

<script>
export default {
    props: ['value']
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/table/value/links/Company.vue